import { ResponsiveWrapper } from '@/components/atoms/ResponsiveWrapper/ResponsiveWrapper';
import { HeroSection } from '@/components/organisms/HeroSection';
import { HomePageCalculatorSection } from '@/components/organisms/HomePageCalculatorSection/HomePageCalculatorSection';
import { HomePageCompareCarousel } from '@/components/organisms/HomePageCompareCarousel//HomePageCompareCarousel';
import { HomePageShopType } from '@/components/organisms/HomePageShopType/HomePageShopType';
import { SocialMediaCard } from '@/components/organisms/SocialMediaCard/SocialMediaCard';
import { CarAIBanner } from '@/components/organisms/CarAIBanner';
import { FC } from 'react';
import { PopularModelsLinks } from '@/components/molecules/PopularModelsLinks';
import { HomePageRecentArticles } from '../../organisms/HomePageRecentArticles';

export interface HomeTemplateProps {
  makes: string[];
  models: { [key: string]: string[] };
}

export const HomeTemplate: FC<HomeTemplateProps> = ({ makes, models }) => {
  return (
    <div className="relative w-full">
      <section className="bg-neutral-100 md:py-[36px]">
        <ResponsiveWrapper>
          <HeroSection makes={makes} models={models} />
        </ResponsiveWrapper>
      </section>

      <ResponsiveWrapper>
        <HomePageCompareCarousel />
      </ResponsiveWrapper>

      <ResponsiveWrapper>
        <HomePageShopType makes={makes} />
      </ResponsiveWrapper>

      <div className="pt-xl">
        <HomePageCalculatorSection />
      </div>

      <HomePageRecentArticles />

      <CarAIBanner />

      <ResponsiveWrapper>
        <SocialMediaCard />
      </ResponsiveWrapper>

      <PopularModelsLinks condition="new" />
    </div>
  );
};
